import { Component, Input, OnInit } from '@angular/core';
import { NavService } from '../nav.service';
import { Nav } from '../nav.interface';


@Component({
  moduleId: module.id,
  template: '',
})
export class NavItemBaseComponent implements Nav, OnInit {
  @Input() active: boolean = false;
  @Input() disabled: boolean = false;
  @Input() data: any;
  @Input() name: string = '';

  constructor(protected navService: NavService) {}

  ngOnInit() {
    this.navService.addNav(this);
  }
}
